import { InjectionToken } from '@angular/core';

export const CALENDAR_SYNC_API_BASE_URL = new InjectionToken<string>('CALENDAR_SYNC_API_BASE_URL');
